import { faPersonSimple, faPlateUtensils } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from 'i18next';
import { Form, InputGroup } from 'react-bootstrap';

import { Recipe } from 'types/Recipe/Recipe';

interface IProps {
	recipe: Recipe;
	handleSetRecipeAttribute: (key: keyof Recipe, value: number | null) => void;
}

const RecipeScalingEditor = (props: IProps) => {
	const handleValueChangeServings = (value: number): void => {
		props.handleSetRecipeAttribute('parts', value > 0 ? value : null);
		props.handleSetRecipeAttribute('persons', value > 0 ? value : null);
	};

	const handleValueChangeServingsPerPerson = (value: number): void => {
		props.handleSetRecipeAttribute('scaledParts', value > 0 ? value : null);
		props.handleSetRecipeAttribute('scaledPersons', value > 0 ? value : null);
	};

	return (
		<div className="d-flex">
			<InputGroup className="mb-3">
				<InputGroup.Text>
					<FontAwesomeIcon icon={faPlateUtensils} />
				</InputGroup.Text>
				<Form.Control
					type="number"
					onChange={(input) => handleValueChangeServings(Number(input.target.value))}
					value={props.recipe.parts ?? 0}
				/>
				<InputGroup.Text>{t('recipe:PARTS_COUNT')}</InputGroup.Text>
			</InputGroup>
			<InputGroup className="mb-3">
				<InputGroup.Text>
					<FontAwesomeIcon icon={faPersonSimple} />
				</InputGroup.Text>
				<Form.Control
					type="number"
					onChange={(input) =>
						handleValueChangeServingsPerPerson(Number(input.target.value))
					}
					value={props.recipe.scaledParts ?? 0}
				/>
				<InputGroup.Text>{t('recipe:SCALED_PARTS_COUNT')}</InputGroup.Text>
			</InputGroup>
		</div>
	);
};

export default RecipeScalingEditor;
